import ProductPage from "@/components/pages/inventory/product/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/inventory/product/_modal/")({
	component: ProductPage,
});
